export const pageVariant = {
    initial: {
        opacity: 0
    },
    animate: {
        opacity: 1,
        transition: { duration: 0.7 }
    },
    exit: {
        opacity: 0,
        transition: { duration: 0.3 }
    }
}